import {
    GET_NOTIFICATIONS,
    GET_NOTIFICATIONS_SUCCESS,
    GET_NOTIFICATIONS_FAILURE,
    GET_NOTIFICATIONS_NUMBER,
    GET_NOTIFICATIONS_NUMBER_SUCCESS,
    GET_NOTIFICATIONS_NUMBER_FAILURE
} from './constants';

const initialState = {
    notifications: { notifications: [], loading: false, loaded: false, error: null },
    notifications_count: { count: 0, loading: false, loaded: false, error: null },
};

const notifications = (state = initialState, action) => {
    switch (action.type) {
        case GET_NOTIFICATIONS:
            return {
                ...state,
                notifications: { ...state.notifications, loading: true, loaded: false, error: null }
            };
        case GET_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                notifications: { notifications: action.payload, loading: false, loaded: true, error: null }
            };
        case GET_NOTIFICATIONS_FAILURE:
            return {
                ...state,
                notifications: { ...state.notifications, loading: false, loaded: false, error: action.payload.message }
            };
        case GET_NOTIFICATIONS_NUMBER:
            return {
                ...state,
                notifications_count: { ...state.notifications_count, loading: true }
            };
        case GET_NOTIFICATIONS_NUMBER_SUCCESS:
            return {
                ...state,
                notifications_count: { count: action.payload.notifications_count, loading: false, loaded: true, error: null }
            };
        case GET_NOTIFICATIONS_NUMBER_FAILURE:
            return {
                ...state,
                notifications_count: { ...state.notifications_count, loading: false, loaded: false, error: action.payload.message }
            };
        default:
            return state;
    }
};

export default notifications;
